import Box from '@mui/material/Box';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import playerProvider from '../../utils/playerProvider';
import getSceneDefinition from '../../utils/getSceneDefinition';
import { getConfigSceneDefinition } from '../../utils';
import { useOutletContext } from 'react-router-dom';
import { ControlToolbar } from '../Maquette/ControlToolbar';
import Loading from '../Loading';
import { useTheme } from '@mui/material/styles';
import { JoyrideMaquetteLot } from '../Joyride/JoyrideMaquetteLot';
import { MentionContractuel } from '../Mention/MentionContractuel';

export default function MaquetteLot({ media }) {
  const PlayerContainerRef = useRef();
  const currentKeyRef = useRef();
  const subscriber = useRef(true);
  const [currentAngle, setCurrentAngle] = useState();
  const [loading, setLoading] = useState(true);
  const [drag, setDrag] = useState(false);
  const player = playerProvider.getInstance('orbitalInt');
  const [isFullscreen, setIsFullscreen] = useState(false);
  const PlayerLayoutRef = useRef();
  const _infos = useOutletContext();
  const theme = useTheme();
  const infos = useMemo(() => {
    return { ..._infos };
  }, [_infos]);

  if (media) {
    infos.lot = media;
  }
  // Initialisation
  useEffect(() => {
    player.setMouseDragMode(false);
    PlayerContainerRef.current.appendChild(player.getDomElement());
    subscriber.current = player.rotator.rotateValue.subscribe(setCurrentAngle);
    window.addEventListener('resize', player.resize.bind(player));
    player.resize();
    player.setZoom(1);
    return () => {
      window.removeEventListener('resize', player.resize);
      subscriber.current.unsubscribe();
    };
  }, [player]);

  // Préparation maquette
  useEffect(() => {
    if (!infos) return;
    const { settings, lot } = infos;
    if (lot?.key === currentKeyRef.current) return;
    setLoading(true);
    currentKeyRef.current = lot.key;
    const { fps, loDef, hiDef, hasAlpha, fullpath, fov } =
      getConfigSceneDefinition(
        settings.settings,
        lot.medias,
        settings.mediaBaseUrl,
      );

    const sceneDefinition = getSceneDefinition(
      fov,
      fullpath,
      [],
      [],
      [],
      fps,
      loDef,
      hiDef,
      settings,
      hasAlpha,
      true,
      theme,
    );
    player.setScene(sceneDefinition, true).then(() => {
      setLoading(false);
    });
  }, [player, infos]);

  useEffect(() => {
    player.setMouseDragMode(drag);
  }, [drag, player]);
  const handleFullscreen = useCallback(() => {
    if (!PlayerLayoutRef) return;

    if (isFullscreen) {
      document
        .exitFullscreen()
        .then(function () {
          setIsFullscreen(false);
        })
        .catch(function (error) {
          console.log(error.message);
        });
    } else {
      PlayerLayoutRef.current
        .requestFullscreen()
        .then(function () {
          setIsFullscreen(true);
        })
        .catch(function (error) {
          console.log(error.message);
        });
    }
  }, [isFullscreen]);
  return (
    <Box
      ref={PlayerLayoutRef}
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
        backgroundColor: infos?.settings?.maquette?.backgroundColor || 'white',
        canvas: {
          mixBlendMode: infos?.settings?.maquette?.mixBlendMode || 'multiply',
        },
      }}
    >
      <MentionContractuel />
      <Box
        ref={PlayerContainerRef}
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          overflow: 'auto',
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            opacity: 0.05,
            zIndex: 10,
            pointerEvents: 'none',
            backgroundImage:
              'radial-gradient(circle, rgba(2,0,36,0) 0%, rgba(1,0,20,0) 50%, rgba(0,0,0,3) 100%)',
          },
        }}
      />
      {loading ? (
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            top: 0,
            bottom: 0,
          }}
        >
          <Loading />
        </Box>
      ) : null}

      <JoyrideMaquetteLot />

      <Box
        className="palette-control-maquette"
        sx={{
          position: 'absolute',
          bottom: 20,
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      >
        <ControlToolbar
          angle={currentAngle}
          drag={drag}
          setDrag={setDrag}
          rotateLeft={() => player.rotateLeft()}
          rotateRight={() => player.rotateRight()}
          zoomIn={() => player.zoomIn()}
          zoomOut={() => player.zoomOut()}
          isFullscreen={isFullscreen}
          fullscreen={handleFullscreen}
        />
      </Box>
    </Box>
  );
}
